<template>
	<div class="form-pc-container">
		<div class="title-container">
      <div class="form-title" v-if="checkTip()">
        {{ props.payload.content.tip }}
      </div>
      <div class="form-finish-title-right" v-if="props.payload.nodeStatus == 2" >
        <Icon :src="iconSucess" style="margin:0px 4px"/>
        <div class="form-finish-title">
          {{ TUITranslateService.t("AIDesk.已提交") }}
        </div>
      </div>
		</div>

		<div
      v-for="(item, index) in props.payload.content.inputVariables"
      :key="index"
		>
      <LabelPC :name="item.name" :is-required="item.isRequired" />
      <div v-if="item.formType == 0 && props.payload.nodeStatus !== 2">
        <InputPC :placeholder="item.placeholder" :variableValue="item.variableValue" :name="item.name" :isRequired="item.isRequired" @input-change="handleInputChange" :validator="item.isRequired == 1 && isValid(item.name)" :isDisabled="props.payload.nodeStatus === 1"/>
      </div>
      <div v-else-if="item.formType == 1 && props.payload.nodeStatus !== 2">
        <RadioPC :chooseItemList="item.chooseItemList" :name="item.name" :isRequired="item.isRequired" @input-change="handleInputChange" :validator="item.isRequired == 1 && isValid(item.name)" :isDisabled="props.payload.nodeStatus === 1"/>
      </div>
      <div v-else class="variable-value-container">
        {{ item.variableValue == '' ||  item.variableValue == null ? mapValue[item.name] : item.variableValue}}
      </div>
		</div>
		<div class="button-container" v-if="props.payload.nodeStatus !== 2">
      <div :class="props.payload.nodeStatus === 1 ? 'button-disable' : 'button'" @click="handleSendForm">
        {{ TUITranslateService.t("AIDesk.提交") }}
      </div>
		</div>
	</div>

</template>
<script lang="ts">
import vue from '../../../../../../../adapter-vue';
import { customerServicePayloadType } from '../../../../../../../interface';
import LabelPC from './component-pc/label-pc.vue';
import InputPC from './component-pc/input-pc.vue';
import RadioPC from './component-pc/radio-pc.vue';
import Icon from '../customer-icon.vue';
import iconSucess from '../../../../../../../assets/icon_success.png';
import { CUSTOM_MESSAGE_SRC } from '../../../../../../../constant';
import {TUITranslateService} from '../../../../../../../@aidesk/uikit-engine';
const { ref, onMounted } = vue;
interface Props {
  payload: customerServicePayloadType;
}
export default {
  components: {
    LabelPC,
    InputPC,
    RadioPC,
    Icon
  },
 props: {
  payload: {
    type: Object as () => customerServicePayloadType,
    default: () => ({}),
  },
  },
  emits: ['sendMessage'],
  setup(props: Props, { emit }) {
    const mapValue=ref({});
    const isSubmit = ref<boolean>(false);
    const hasNullValue = ref<boolean>(true);
    onMounted(()=>{
      let inputVariables = props.payload.content.inputVariables ?? [];
      for (let i = 0; i < inputVariables.length; i++) {
        const name = inputVariables[i].name;
        const variableValue = inputVariables[i].variableValue;
        mapValue.value[name] = variableValue;
      }
    });

    const checkTip = () => {
      return props.payload.content.tip != '' && props.payload.content.tip != null;
    }

    const checkValidator = (name:string) => {
      hasNullValue.value = false;
      if (isSubmit.value == true) {
        if (mapValue.value[name] == null || mapValue.value[name] == '') {
          hasNullValue.value = true;
          return true;
        }
      }
      return false;
    }

    const handleSendForm = (data: any) => {
      if (props.payload.nodeStatus === 1) {
        return;
      }
      isSubmit.value = true;
      let list = props.payload.content.inputVariables;
      for (let i = 0; i < list.length; i++) {
        let value = mapValue.value[list[i].name];
        if (value !='' && value != null) {
          list[i].variableValue = value;
        } else {
          if (list[i].isRequired === 1 && checkValidator(list[i].name)) {
            return;
          }
        }
      }
      const submitData = {
        data: JSON.stringify({
          src: CUSTOM_MESSAGE_SRC.MULTI_FORM,
          content: {
            inputVariables: list
          },
          customerServicePlugin: 0,
        }),
      };
      emit('sendMessage', submitData);
      isSubmit.value = false;
    };

    const handleInputChange = ({name,value}) =>{
      mapValue.value[name] = value;
    }

    const showValue = (name:string,variableValue:string) => {
      if (variableValue != null && variableValue != '') {
        return variableValue
      }
      return mapValue.value[name];
    }
    const isValid = (name:string) => {
      return isSubmit.value && (mapValue.value[name] == null || mapValue.value[name] == '' || mapValue.value[name] == undefined);
    }
    return {
      props,
      handleSendForm,
      handleInputChange,
      iconSucess,
      checkValidator,
      showValue,
      mapValue,
      isSubmit,
	    checkTip,
      isValid,
      TUITranslateService
    };
  },
};
</script>
<style lang="scss">
.form-pc-container {
  max-width: 350px;
}
.title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  width: 100%;
}
.form-title {
  flex: 1;
  min-width: 0; 
  overflow-wrap: break-word;
  word-break: normal;
  padding-right: 8px;
  box-sizing: border-box;
}
.form-finish-title-right {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  max-width: 100%;
}
.button-container {
  display: flex;
  justify-content: center;
  margin-top: 15px;
  .button {
    display: flex;
    justify-content: center;
    width: 87px;
    padding: 6px 10px;
    background-color: #1c66e5;
    color: white;
    border-radius: 20px;
    cursor: pointer;
  }
  .button-disable {
    background-color: #dbdbdb;
    display: flex;
    justify-content: center;
    width: 87px;
    padding: 6px 10px;
    color: white;
    border-radius: 20px;
  }
}
.variable-value-container {
  padding-bottom: 8px;
  margin-top: 3px;
  overflow-wrap: break-word;
  word-break: normal;
}
.form-finish-title {
  word-break: keep-all;
  white-space: nowrap;
}
</style>
